import React from 'react';
import { Grid, Typography, Button, ButtonGroup, useTheme } from '@mui/material';

const CurrencyOptions = ({ setIsInUSD, isInUSD }) => {
  const theme = useTheme();

  const handleIsInUSDChange = newIsInUSD => {
    setIsInUSD(newIsInUSD);
  };

  // Función para reutilizar estilos de los botones
  const buttonStyles = (selected, borderRadius) => ({
    flex: 1,
    fontSize: { xs: '14px', sm: '16px' },
    borderRadius,
    color: '#636466',
    backgroundColor: selected ? '#C7C7C7' : '#FFFFFF',
    '&:hover': {
      backgroundColor: selected ? '#C7C7C7' : '#f0f0f0',
      color: theme.text1,
    },
  });

  return (
    <Grid
      container
      justifyContent="center"
      sx={{
        width: '100%',
        maxWidth: '200px',
        margin: '0 auto',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Grid sx={{ width: '100%', borderRadius: '8px' }}>
        {/* Header */}
        <Grid
          item
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            height: '25px',
            width: '100%',
            padding: 0,
            backgroundColor: theme.primary || '#000',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '14px', sm: '16px' },
              fontWeight: 600,
              color: theme.text1 || '#fff',
              lineHeight: 1,
              margin: 0,
            }}
          >
            Buscá tu vuelo en
          </Typography>
        </Grid>

        {/* Botones de moneda */}
        <Grid item sx={{ width: '100%' }}>
          <ButtonGroup sx={{ height: '25px', width: '100%' }}>
            <Button
              onClick={() => handleIsInUSDChange(false)}
              sx={buttonStyles(!isInUSD, '0px 0px 0px 8px')}
            >
              PESOS
            </Button>
            <Button
              onClick={() => handleIsInUSDChange(true)}
              sx={buttonStyles(isInUSD, '0px 0px 8px 0px')}
            >
              DOLARES
            </Button>
          </ButtonGroup>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CurrencyOptions;
